import React from 'react';
import { IonLoading } from '@ionic/react';

type AppLoadingProps = {
  hidden: boolean | undefined;
};

export default function AppLoading({ hidden }: AppLoadingProps) {
  return <IonLoading isOpen={!hidden} color="primary" />;
}
